import React from 'react';
import { CalendarCell } from '@/components/organisms/EventCalendar/types';
import CalendarDayCell from '@/components/atoms/CalendarDayCell/CalendarDayCell';
import './EventCalendarGrid.scss';

interface EventCalendarGridProps {
  cells: CalendarCell[];
  onSelectEvent: (eventId: number) => void;
  formatTime: (value: string) => string;
}

const EventCalendarGrid: React.FC<EventCalendarGridProps> = ({ cells, onSelectEvent, formatTime }) => {
  return (
    <div className="events-calendar-page__grid">
      {cells.map(cell => (
        <CalendarDayCell
          key={cell.key}
          cell={cell}
          onSelectEvent={onSelectEvent}
          formatTime={formatTime}
        />
      ))}
    </div>
  );
};

export default EventCalendarGrid;
